export function buildDefaultPeriodeOptions(): string[] {
  const year = new Date().getFullYear();
  const options: string[] = [];
  for (let y = year; y >= year - 3; y -= 1) {
    options.push(`${y}-S2`, `${y}-S1`);
  }
  return options;
}

export function buildPeriodeCode(year: number, semester: 1 | 2): string {
  return `${year}-S${semester}`;
}

export function parsePeriodeCode(periode: string): { year: number; semester: 1 | 2 } | null {
  const match = periode.match(/^(\d{4})-S([12])$/);
  if (!match) return null;
  return { year: Number(match[1]), semester: Number(match[2]) as 1 | 2 };
}

export function formatPeriodeLabel(periode: string): string {
  const match = periode.match(/^(\d{4})-S([12])$/);
  if (!match) return periode;
  return `${match[1]} — Semestre ${match[2]}`;
}
